import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Search_RequestBody } from '@opensearch-project/opensearch/api';

import { useIsServerSide, useSelectedStore } from '@/hooks';
import { useEcomStoreSelector } from '@/data';
import { EnumCustomerType, TreezStore } from '@/types';

import { useSearchService } from '../services';

const useSearch = ({
  searchBody,
  id,
  selectedCustomerType,
  selectedStore,
}: {
  searchBody: Search_RequestBody;
  id?: string;
  selectedCustomerType?: EnumCustomerType;
  selectedStore?: TreezStore;
}) => {
  const { isServerSide } = useIsServerSide();
  const { store } = useSelectedStore();
  const storeToUse = store || selectedStore;
  const { customer_type } = useEcomStoreSelector(['customer_type']);
  const customerTypeToUse = isServerSide ? selectedCustomerType : customer_type;
  const body = JSON.stringify(searchBody);

  const { search } = useSearchService({
    selectedStore: storeToUse,
    selectedCustomerType: customerTypeToUse,
  });

  const storeKey = store?.shortName || selectedStore?.shortName;
  const customerTypeKey = customer_type || selectedCustomerType;

  const queryKey = [id ?? 'products-search', storeKey, customerTypeKey, body];

  //TODO: change this to an infinite query
  const { data, isLoading, error, refetch, status, isFetching } = useQuery({
    queryKey,
    queryFn: async () => {
      const result = await search({ searchBody });
      return result;
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 1, // 1 minutes
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    status,
    isFetching,
  };
};

export { useSearch };
